export default __webpack_public_path__ + "static/media/close.43313a40.svg";